import { DynamicPageConfig } from 'compobot-dynamic-page';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import { defaultColors } from './defaultValues';

export const createDefaultPreviewConfig = (): DynamicPageConfig => ({
  pretext: { en: '', hu: '', color: defaultColors.pretext },
  title: { en: '', hu: '', color: defaultColors.title },
  subtitle: { en: '', hu: '', color: defaultColors.subtitle },
  overlay_color: defaultColors.overlay,
  backgroundImageSrc:
    'https://dev.compocity.help/public/gui_versions/world_bee_day_TEST/assets/background.jpg',
  qr: { en: '', hu: '' },
});

export const updatePreviewConfig = (
  watchedValues: CreateGuiVersionType,
  colors: { pretext: string; title: string; subtitle: string; overlay: string },
): DynamicPageConfig => ({
  pretext: {
    en: watchedValues.pretextEn || '',
    hu: watchedValues.pretextHu || '',
    color: colors.pretext,
  },
  title: {
    en: watchedValues.titleEn || '',
    hu: watchedValues.titleHu || '',
    color: colors.title,
  },
  subtitle: {
    en: watchedValues.subtitleEn || '',
    hu: watchedValues.subtitleHu || '',
    color: colors.subtitle,
  },
  overlay_color: colors.overlay,
  backgroundImageSrc: watchedValues.backgroundImage || '',
  qr: {
    en: watchedValues.qrCodeEn || '',
    hu: watchedValues.qrCodeHu || '',
  },
});
